"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var custom_chip_module_scss_1 = __importDefault(require("./custom-chip.module.scss"));

var Cancel_1 = __importDefault(require("@material-ui/icons/Cancel"));

var core_1 = require("@material-ui/core");

var CustomChip = function CustomChip(_ref) {
  var keyword = _ref.keyword,
      onDeleteClick = _ref.onDeleteClick;
  return react_1.default.createElement(core_1.Grow, {
    in: true
  }, react_1.default.createElement("div", {
    className: custom_chip_module_scss_1.default.root
  }, react_1.default.createElement("span", null, keyword), react_1.default.createElement(Cancel_1.default, {
    onClick: onDeleteClick,
    className: custom_chip_module_scss_1.default.icon
  })));
};

exports.default = CustomChip;